<template>
    <div>
        <!--查看业务咨询人-->
        <e-dialog
                dialogTitle="查看业务咨询人"
                :centerDialogVisible="businessAdvisorVisible"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'580px'">
            <e-table-list
                    maxHeight="400"
                    :loading="false"
                    rowKey="businessConsultEmail"
                    :table-data="tableData"
                    :table-label="tableLabel" >
            </e-table-list>
        </e-dialog>
    </div>
</template>

<script>
    import eDialog from "@/modules/projectA/components/common/e-dialog.vue";
    import eTableList from "../../../components/common/e-table-list";
    import api from '@/modules/projectA/api/ESorganization/index';

    export default {
        name: "businessAdvisorDialog",
        components: {eDialog, eTableList},
        props: {
            businessAdvisorVisible: Boolean,
            evaluationId:Number
        },
        data(){
            return{
                tableData:[],
                tableLabel: [
                    // {label: '序号', slot: 'showIndex', align: 'center', width: '80px',},
                    {label: "业务咨询人", param: "businessConsultName", align: "center"},
                    {label: "电话", param: "businessConsultTel", align: "center"},
                    {label: "邮箱", param: "businessConsultEmail", align: "center"},
                ],
            }
        },
        methods: {
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){

            },
            // 产品质量评价申请-查看更多业务咨询人-供应商
            async queryConsultList() {
                let res = await api.queryConsultList({evaluationId:this.evaluationId});
                if (res.success) {
                    this.tableData = res.data || [];
                }
            },
        },
        mounted() {
            this.queryConsultList();
        }
    }
</script>

<style scoped lang="scss">

</style>